var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section-wrapper',{staticClass:"appointment",attrs:{"this-section":_vm.Section.APPOINTMENT,"section-end-button-in-dom":false}},[_c('iframe',{staticClass:"appointment__iframe",attrs:{"src":_vm.settings.onlineAppointmentSchedulerUrl,"title":_vm.$t('investmentProposal.closeWith.appointment.linkLabel')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }